export default function adjustReviewScore(actualScore) {
	// upperBound & lowerBound define the inclusive range of a half-point
	// anything in range is rounded up to the next half-point
	// anything above upperBound is rounded up to the next full point
	// anything below range is rounded down
	const upperBound = 0.54, lowerBound = 0.1;

	let adjustedScore = Math.floor(actualScore);
	let remainder = actualScore - adjustedScore;

	if (remainder > upperBound) {
		adjustedScore += 1;
	} else if (remainder <= upperBound && remainder >= lowerBound) {
		adjustedScore += 0.5;
	}

	return adjustedScore;
}
